module.exports = __webpack_public_path__ + "img/nuova_prenotazione.9969f148.svg";